import axios from "axios";
import {ElLoading, ElMessage} from 'element-plus'
import router from "@/router";
import {getJsonData} from "@/utils/untils.js";
import {useJsonStore} from "@/store/jsonStore.js";
import {useInfoStore} from "@/store/index.js";
/**
 * 获取省市地区
 * @returns {Promise<unknown>}
 * type old为旧地区格式的json
 * news 为开发ai报志愿时新传的地区json
 */
export const getCityAll = async (type = 'old') => {
    try {
        if (type === 'old') {
            const jsonData = useJsonStore()
            const list = jsonData.getOssList
            const res = await getJsonData({url:list.areas})
            return res
        } else {
            const res = await getJsonData({url:'cache/ai/provinces' })
            return res
        }

    } catch (err) {

    }

}

/**
 * 获取专业信息
 * @returns {Promise<unknown>}
 */
export const getMajorsAll = async () => {
    try {
        const jsonData = useJsonStore()
        const list = jsonData.getOssList
        const res = await getJsonData({url:list.major_list})
        return res
    } catch (err) {

    }

}
/**
 * 获取格式化时间
 */
export function formatTimestamp(timestamp) {
    if (!timestamp) return ''
    // 将时间戳转换为毫秒
    const date = new Date(timestamp * 1000);

    // 获取年月日
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需加1
    const day = String(date.getDate()).padStart(2, '0');

    // 获取时分秒
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    // 返回格式化的日期和时间
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

export const getOnLineAssets = (url) => {
    return 'https://oss.shudaozaixian.com/assets/' + url;
}
export const getOnLineAssetsByPc = (url) => {
    return 'https://oss.shudaozaixian.com/assets/pc/' + url;
}

/**
 * 获取枚举列表
 * */
export const getEnumList = (enumData, callBack) => {
    let enumList = []
    for (const key in enumData) {
        if (isNaN(Number(key))) {
            if (callBack) {
                enumList.push(
                    callBack({
                        label: key,
                        value: enumData[key]
                    })
                )
            } else {
                enumList.push({
                    label: key,
                    value: enumData[key]
                })
            }
        }
    }
    return enumList
}
/**
 * 获取志愿权限
 * @param urls
 * @returns {Promise<{data: T, index: number}>}
 */
export const getVolunteerPermissions = async (urls=[]) => {
    urls = urls.map(i=>i=setJsonUrl(i)).map(i=>{
        if (i.includes(process.env.VITE_API_BASE_JSON)){
            return i.replace(process.env.VITE_API_BASE_JSON, process.env.VITE_API_BASE_JSON2)
        }else {
            return i
        }
    })
    const results = await Promise.allSettled(urls.map(url => axios.get(url).then(response => {
        if (response.status === 200) {
            return response.data
        }
    })));
    let delay = 0
    if (results[1].status === 'fulfilled'){
        delay = results[1]?.value?.delay || 0
    }
    for (let i = results.length - 1; i >= 0; i--) {
        if (results[i].status === 'fulfilled') {
            return { data: results[i].value, delay};
        }
    }
}
/**
 * 复制
 */

export function copyToClipboard(textToCopy) {
    if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(textToCopy);
        ElMessage.success("复制成功！");
    } else {
        let textArea = document.createElement("textarea");
        textArea.value = textToCopy;
        textArea.style.position = "absolute";
        textArea.style.opacity = 0;
        textArea.style.left = "-999999px";
        textArea.style.top = "-999999px";
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        return new Promise((res, rej) => {
            document.execCommand('copy') ? res() : rej();
            textArea.remove();
            ElMessage.success("复制成功！");
        });
    }
}

/**
 * 获取当前报考年份
 */
export function getCurrentOrNextYear() {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth(); // 0 = January, 8 = September

    // 如果当前日期在9月1日之后，返回下一自然年
    if (currentMonth >= 8) {
        return currentYear + 1;
    } else {
        return currentYear;
    }
}

/**
 * 去往指定本科专业
 * code name
 */
export const toMajor = ({code='',name=''}={}) => {
  router.push({
      path: '/tools',
      query: {
          type:'zhuanye',
          bz: 'ben',
          major_code: code,
          major_name: name,
      }
  })
}
/**
 *
 * 轮训结果查询
 */
export const pollRequest = async (fn, data, time = 5) => {
    for (let i = 0; i < time; i++) {
        try {
            const res = await fn(data);
            return res
        } catch (error) {
            if (i < time - 1) {
                await new Promise(resolve => setTimeout(resolve, (10 / (time - i)) * 1000));
            } else {
                await Promise.reject()
            }
        }
    }
}


/**
 * 是否教师登录
 */
export const isTeacher = () => {
    return window.location.host.includes('teacher-login')
}
/**
 *
 * @returns {boolean}
 */
export const isLocal = () => {
    const arr = ['localhost','feifan.jiazhiyuan.net']
    return arr.some(i=>window.location.host.indexOf(i) > -1)
}
export const getIsTest = () => {
    const arr = ['webtest.shudaozaixian.com','localhost','teacher-login','feifan.jiazhiyuan.net','t.jiazhiyuan.net','pc-shudaozaixian-web-test1']
    return arr.some(i=>window.location.host.indexOf(i) > -1)
}
export const getShowAiStatus = () => {
    const arr = ['t.jiazhiyuan.net','webtest.shudaozaixian.com','localhost','teacher-login','feifan.jiazhiyuan.net','pc-shudaozaixian-web-test1']
    return arr.some(i=>window.location.host.indexOf(i) > -1)
}
/**
 * 下载
 */
export  const downloadFile = (url, filename)=> {
    let xhr = new XMLHttpRequest();
    xhr.open("get", url, true);
    xhr.setRequestHeader("Content-Type", `application/json`);
    xhr.responseType = "blob";
    xhr.onload = function () {
        if (this.status == 200) {
            //接受二进制文件流
            const blob = this.response;
            downloadExportFile(blob, filename);

        }
    };
    xhr.send();
}
const downloadExportFile = (blob, fileName)=> {
    let downloadElement = document.createElement("a");
    let href = blob;
    if (typeof blob == "string") {
        downloadElement.target = "_blank";
    } else {
        href = window.URL.createObjectURL(blob); //创建下载的链接
    }
    downloadElement.href = href;
    downloadElement.download = fileName;
    document.body.appendChild(downloadElement);
    downloadElement.click(); //点击下载
    document.body.removeChild(downloadElement); //下载完成移除元素
    if (typeof blob != "string") {
        window.URL.revokeObjectURL(href); //释放掉blob对象
    }
}

/*
* 时间对象处理
* new Date  转  Y-M-D
*/
export function reviseTime(dateObj = new Date(), format = 'Y-M-D') {
    const dt = new Date(dateObj)
    const year = dt.getFullYear() // 年
    let month = dt.getMonth() + 1 // 月
    let date = dt.getDate() // 日
    const h = dt.getHours() < 10 ? '0' + dt.getHours() : dt.getHours() //  时
    const m = dt.getMinutes() < 10 ? '0' + dt.getMinutes() : dt.getMinutes() // 分
    const s = dt.getSeconds() < 10 ? '0' + dt.getSeconds() : dt.getSeconds() // / 秒
    month = month < 10 ? '0' + month : month
    date = date < 10 ? '0' + date : date
    if (format == 'Y-M-D H:M:S') {
        return year + '-' + month + '-' + date + ' ' + h + ':' + m + ':' + s
    } else if (format == 'YMDHMS') {
        return year + month + date + h + m + s
    } else if (format == 'H:M') {
        return h + ':' + m
    } else if (format == 'H:M:S') {
        return h + ':' + m + ':' + s
    } else if (format == 'Y-M-D') {
        return year + '-' + month + '-' + date
    } else if (format == 'YM') {
        return year + month
    } else if (format == 'Y/M') {
        return year + '/' + month
    }else if (format == '年-月-日') {
        return year + '年' + month + '月' + date + '日'
    }else if (format == 'Y-M-D H:M') {
        return year + '-' + month + '-' + date + ' ' + h + ':' + m
    }else if (format == 'H:M:S') {
        return  h + ':' + m + ':' + s
    }
}

/**
 * 校验过期时间
 * true 过期
 */
export const verificationTime = () => {
    const now = new Date().getTime()
    const time = Number(localStorage.getItem('overTime') || 0);
    return now>time
}
/**
 * 获取默认省份id
 */
export const getDefaultProvinceId = () => {
    return new Promise((resolve,reject)=>{
        const provinceId = localStorage.getItem('province_id')
        if(Number(provinceId)>0){
            resolve(provinceId)
            return
        }
        const agentId = sessionStorage.getItem('domain')
        if(!agentId){
            resolve(11)
            return
        }
        getJsonData({url: `cache/agent_open_province/${agentId}`}).then(res=>{
            if (res&&res.length) {
                resolve(res[0])
            }else {
                resolve(11)
            }
        }).catch(()=>{
            resolve(11)
        })
    })
}

/**
 * 判断是否为obj
 */
export const isObject = (obj) => {
    return typeof obj === 'object' && obj !== null && !Array.isArray(obj);
}
/**
 * 映射oss地址
 */
export const mappingUrl = (url) => {
    if (typeof url !== 'string'){
        throw new Error('url must be string')
    }
    if (url.includes('jiazhiyuan.net')) {
        return url.replace('oss.jiazhiyuan.net','zhangjiakou-info-test.oss-cn-zhangjiakou.aliyuncs.com')
    }else if (url.includes('shudaozaixian.com')){
        return url.replace('oss.shudaozaixian.com','zhangjiakou-info.oss-cn-zhangjiakou.aliyuncs.com')
    }else {
        return url
    }
}
export const isTestHost = (index = -1) => {
    const hostList = ['phpwebtest.jiazhiyuan.net','feifan.jiazhiyuan.net','localhost:5173','webtest.shudaozaixian.com','pc-shudaozaixian-web-test1','teacher-login-java-ai.jiazhiyuan.net','java-ai-t.jiazhiyuan.net']
    const host = window.location.host
    return index === -1 ? hostList.includes(host):Boolean(hostList[index])
}

/**
 * 截取字符串
 * @param input 字符串
 * @param length 长度加 ...
 * @returns {string}
 */
export function spliceStrings(input, length=0) {
    if (typeof input !== 'string') {
        return '';
    }
    if (input.length <= length || !length) {
        return input;
    }
    return input.substring(0, length) + '...';
}


/**
 * 拦截json请求是否增加时间戳
 */
// 需要实时增加时间戳的json关键字
export const needAllIn = [
    'cache/agent_cms_info',
    'cache/v',
    'cache/notice',
    'cache/power',
    'cache/law',
    'cache/list_',
    'cache/list',
    'cache/agent_open_province',
    'popup'
]
export const needThreeIn = [

]
function isMD5OrEndsWithTenDigitNumber(input) {
    // 正则表达式用于匹配 MD5 和以 10 位数字结尾的字符串
    const md5Regex = /^[a-f0-9]{32}$/; // MD5 是 32 个十六进制字符
    const tenDigitEndingRegex = /\d{10}$/; // 以 10 位数字结尾

    return md5Regex.test(input) || tenDigitEndingRegex.test(input);
}
export const setJsonUrl = (url)=>{
    if (typeof url !== 'string'){
        return ''
    }
    if (url.includes('?')){
        url = url.split('?')[0]
    }
    if (url.endsWith('.json')) {
        url = url.slice(0, -5); // 去掉最后的 .json
    }
    const timeV = localStorage.getItem('time_v') || 1
    const time = new Date().getTime()
    const finTime = Math.floor(time/(1000*timeV))
    if (needAllIn.some(i=>url.includes(i))){
        // 如果是需要强刷新的json 则每次请求都要增加时间戳
        return `${url}.json?v=${finTime}`
    }
    // if (needThreeIn.some(i=>url.includes(i))){
    //     // 如果是需要强刷新的json 则每次请求都要增加30分钟时间戳
    //     const finTime = Math.floor(time/(60*30*1000))
    //     return `${url}.json?v=${finTime}`
    // }
    const lastKey = url.split('/')[url.split('/').length-1]
    if (lastKey && window?.location?.hostname === lastKey){
        return `${url}.json?v=${finTime}`
    }
    if (lastKey&&isMD5OrEndsWithTenDigitNumber(lastKey)){
        // 如果是md5加密或者自带时间戳的链接，则直接返回
        return url+'.json'
    }else {
        return `${url}.json?v=${localStorage.getItem('json_v')}`
    }

}
/**
 * 获取uuid
 * @param len
 * @param radix
 * @returns {string}
 */
export function uuid(len, radix) {
    var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
    var uuid = [], i;
    radix = radix || chars.length;
    if (len) {
        // Compact form
        for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix];
    } else {
        // rfc4122, version 4 form
        var r;
        // rfc4122 requires these characters
        uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
        uuid[14] = '4';
        // Fill in random data.  At i==19 set the high bits of clock sequence as
        // per rfc4122, sec. 4.1.5
        for (i = 0; i < 36; i++) {
            if (!uuid[i]) {
                r = 0 | Math.random() * 16;
                uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r];
            }
        }
    }
    return uuid.join('');

}
export const setUUID = () => {
    sessionStorage.setItem('uuidInfo', uuid(32, 32))
}
export const getUUID = () => {
    return {
        'Idempotency-Key': sessionStorage.getItem('uuidInfo')
    }
}
export const checkRequestApiList = [
    "/regist",
    "/inputScore",
    "/savePlans",
    "/insertAiInfo",
    "/saveAiTest",
    "/generateReport",
    "/addStudentAdvise",
    '/updateAiInfo',
    '/updateDetailCollection',
    '/buildCard'
    // "/paymentVip",
    // "/paymentNumber",
    // "/single/payment"
]
/**
 *
 *
 */
export const setJsonData = ({vm,list}={}) => {

}

/**
 * 还原缩放
 */
export function adjustForScaling() {
    // 判断是否为 PC 终端
    const isPC = () => {
        return /Win|Mac|Linux/.test(navigator.platform);
    };

    // 获取桌面缩放比例
    const getScaleFactor = () => {
        return window.devicePixelRatio || 1; // 默认比例为 1
    };

    // 还原缩放
    const restoreScaling = () => {
        if (isPC()) {
            const scaleFactor = getScaleFactor();
            console.error('scaleFactor',scaleFactor)
            if (scaleFactor > 1) { // 仅当缩放比例大于 100% 时才还原
                document.body.style.transform = `scale(${1 / scaleFactor})`;
                document.body.style.transformOrigin = '0 0';
                document.body.style.width = `${100 * scaleFactor}%`;
            }
        }
    };

    // 执行还原缩放
    restoreScaling();
}
export const startLoading = ()=>{
    const userInfo = useInfoStore()
    userInfo.setKey('loading', true)
}
export const endLoading = ()=>{
    const userInfo = useInfoStore()
    userInfo.setKey('loading', false)
}

export const mapSearchForm = (obj={}) => {
  const newsObj = {}
    if (obj?.city_ids?.length){
        newsObj.city = obj.city_ids
    }
    if (obj.follow_major?.length){
        newsObj.benMajor = obj.follow_major.map(i=>i.code)
    }
    if (obj.banyan?.length){
        newsObj.banyan = obj.banyan
    }
    if (obj.educational_type?.length){ // 院校类型
        newsObj.leixing = obj.educational_type.map(i=>i.code)
    }
    if (obj.yiliu?.length){ // 一流学科
        newsObj.yiliu = obj.yiliu
    }
    if (obj.school_level?.length){ // 院校层次
        newsObj.cengci = obj.school_level.map(i=>i.code)
    }
    if (obj.shuobo?.length){ //
        newsObj.shuobo = obj.shuobo
    }
    if (obj.nature_type?.length){ // 院校性质
        newsObj.xingzhi = obj.nature_type.map(i=>i.code)
    }
    if (obj.recruit_type?.length){ //  招生类型
        newsObj.zhaosheng = obj.recruit_type.map(i=>i.code)
    }
    if (obj.school_ids?.length){ // 意向院校
        newsObj.schoolIds = obj.school_ids
    }
    if (obj.shuangwan?.length){
        newsObj.shuangwan = obj.shuangwan
    }
    if (obj.guojia_tese){
        newsObj.guojia_tese = obj.guojia_tese
    }
    if (obj.xueke?.length){ //
        newsObj.xueke = obj.xueke
    }
    const variables = [
        "baoyan",
        "benMajor",
        "gaobenMajor",
        "cengci",
        "guojia_tese",
        "leixing",
        "scoreRange",
        "shuangwan",
        "shuobo",
        "xingzhi",
        "xueke",
        "yiliu",
        "zhaosheng",
        "zhuanMajor",
        "city",
        "schoolIds"
    ];
    variables.forEach(item=>{
       if(!newsObj.hasOwnProperty(item)){
           newsObj[item] = obj.hasOwnProperty(item)?obj[item]:[]
       }
    })
    return newsObj

}


export const isDev = () => {
  return process.env.NODE_ENV === 'development'
}


export function validatePassWordInput(input) {
    // 校验长度：6到18位
    if (input.length < 6 || input.length > 18) {
        return false;
    }
    // 校验是否包含数字
    const hasNumber = /\d/.test(input);
    // 校验是否包含字母
    const hasLetter = /[a-zA-Z]/.test(input);

    // 必须同时包含数字和字母
    return hasNumber && hasLetter;
}
/**
 * 获取高考年份
 * 返回6个年份 如果当前时间大于当年9月1日 则第一个年份为当年份+1 否则第一个年份为当年年份  后续累加 返回7个
 * @returns {*[]}
 */
export const getGaoKaoYears = () => {
    const currentYear = new Date().getFullYear();
    const currentDate = new Date();
    const septemberFirst = new Date(currentYear, 8, 1); // 9月1日 (月份从0开始)

    let startYear = currentDate > septemberFirst ? currentYear + 1 : currentYear;
    let years = [];

    for (let i = 0; i < 7; i++) {
        years.push(startYear + i);
    }

    return years.map(i=>{
        return {text: i,value: i}
    });
}


export const toTop = () => {
  const element = document.querySelector('.app-wrapper')
    console.error('element',element)
    element?.scrollTo({
        top: 0,
        behavior: 'smooth'
    })
}

/**
 * 校验ai聊天权限
 */
export const checkAiChatPressions = () => {
    const flag1 = useJsonStore().getDomain?.merchantType == 3
    const userInfo = useInfoStore().baseInfo?.is_vip
    return flag1&&userInfo || process.env.NODE_ENV ==='development'
}

export const goBack = (flag=1) => {
    if (window.history.length > 1) {
        router.go(-1);
    } else {
        if (flag){
            router.replace({ name: 'home' });
        }else {
            router.push({ name: 'home' });
        }
    }
}